import useResponsive from "@helpers/useResponsive";
import { IBusinessSolution } from "./interface";
import dynamic from "next/dynamic";

const Desktop = dynamic(() => import("./lib/Desktop"));
const Mobile = dynamic(() => import("./lib/MobileV2"));

const BusinessLevelZero: React.FC<IBusinessSolution> = (props: IBusinessSolution) => {
  const { children, dataNavbar } = props;
  const isMobile = useResponsive("md");

  const Component = isMobile ? Mobile : Desktop;

  return <Component children={children} dataNavbar={isMobile ? null : dataNavbar} />;
};

export default BusinessLevelZero;
